import React, {MutableRefObject} from "react";
import IconUserFull from "@Icons/IconUserFull";
import PriceWithCurrency from "@Route/components/Price/PriceWithCurrency";
import useGoBack from "@Routing/hooks/useGoBack";
import Row from "@Containers/components/Row";
import {useTranslation} from "@Translation/hooks/useTranslation";
import Dialog from "@Features/dialog/components/Dialog";
import Button from "@Generic/buttons/Button";
import useGetPriceChangeData from "@CheckOrder/features/modals/hooks/useGetPriceChangeData";

interface PriceChangeModalProps {
    closeModal: () => void,
    dialogRef: MutableRefObject<HTMLDialogElement>
}

const PriceChangeModal = (props: PriceChangeModalProps) => {
    const {
        closeModal,
        dialogRef,
    } = props;

    const {goBack} = useGoBack()

    const {title, message, oldPrice, newPrice, passengersNum, btnText, handleClick} = useGetPriceChangeData()

    const goBackLabel = useTranslation("check_order.back_to_search_results")
    const newPriceLabel = useTranslation("check_order.new_price")

    return (
        <Dialog dialogRef={dialogRef} className="check-order__error-modal price-change" closeModal={goBack}>
            <h4 className="price-change__title">
                {title}
            </h4>
            <div dangerouslySetInnerHTML={{__html: (`${message}`)}}/>
            <br/>
            <Row justify center>
                <span className="gb--emphasize">
                    {newPriceLabel}
                </span>
                &nbsp;
                <Row gap center>
                    <PriceWithCurrency price={oldPrice} className="gb--emphasize old-price"/>
                    <PriceWithCurrency price={newPrice} className="gb--emphasize gb--emphasize-default"/>
                    <span
                        className="gb--row gb--row-middle gb--row-end price-pax gb--label gb--label-default gb--emphasize gb--emphasize-default"
                    >
                        <IconUserFull fill="#070c63"/>
                        {passengersNum}
                    </span>
                </Row>
            </Row>
            <Button onClick={handleClick} className="green" additionalClasses="reload-btn">
                {btnText}
            </Button>
            <Button onClick={goBack} className="primary-transparent">
                {goBackLabel}
            </Button>
        </Dialog>
    )
}

export default PriceChangeModal